// @flow

import React, { Component } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import scriptLoader from 'react-async-script-loader';
import PasswordToggle from '../shared/PasswordToggle';
import AuthInput from '../shared/AuthInput';
import Icon from '../shared/Icon';
import AuthError from './AuthError';

type State = {
  score: number,
  warning: ?string,
  focused: boolean,
  suggestions: string[],
  showPassword: boolean
}

type Props = {
  password: string,
  onChange: (event: SyntheticEvent<HTMLInputElement>) => void,
  error: any
} & WithTranslation

class PasswordInput extends Component<Props, State> {
  props: Props
  state: State = {
    warning: null,
    suggestions: [],
    score: 0,
    showPassword: false,
    focused: false
  }

  componentWillReceiveProps(nextProps: Props) {
    if (nextProps.password !== this.props.password) {
      if (window.zxcvbn) {
        const { t } = this.props;
        const passwordFeedback = t('passwordFeedback:all', { returnObjects: true });
        const { feedback, score } = window.zxcvbn(nextProps.password);
        const warningKey = feedback.warning
          .replace(/[^a-zA-Z]/g, '')
          .toLowerCase()
          .replace(' ', '');
        const suggestions = feedback.suggestions.map((suggestion) => {
          const suggestionKey = suggestion
            .replace(/[^a-zA-Z]/g, '')
            .toLowerCase()
            .replace(' ', '');
          return passwordFeedback[suggestionKey];
        });
        this.setState({
          warning: passwordFeedback[warningKey],
          suggestions: suggestions,
          score
        });
      }
    }
  }

  togglePassword = () => {
    this.setState({
      showPassword: !this.state.showPassword
    });
  }

  onBlur = () => {
    this.setState({
      focused: false
    });
  }

  onFocus = () => {
    this.setState({
      focused: true
    });
  }

  render() {
    let className = '';
    let icon = null;
    let iconClassName = 'is-neutral';
    if (this.state.focused) {
      icon = 'lock-closed';
    }
    if (this.props.password.length > 3) {
      if (this.state.score < 2) {
        className = 'auth-input--weak-pw';
        icon = 'lock-open';
        iconClassName = 'is-danger';
      } else if (this.state.score === 2) {
        className = 'auth-input--med-pw';
        icon = 'lock-mid';
        iconClassName = 'is-warning';
      } else if (this.state.score > 2) {
        className = 'auth-input--strong-pw';
        icon = 'lock-success';
        iconClassName = 'is-success';
      }
    }
    const error = (this.state.warning && this.props.password.length > 3) ?
      (
        <AuthError
          error={{ translatedMessage: this.state.warning || '', field: 'password' }}
          className={`auth-error--pw-${this.state.score || '0'}`}
        />
      ) :
      this.props.error;
    const { t } = this.props;

    return (
      <div>
        <div className='auth-form__row'>
          {icon &&
            <div className='auth-input__icon'>
              <Icon name={icon} className={iconClassName} size='medium' />
            </div>
          }
          <AuthInput
            value={this.props.password}
            onChange={this.props.onChange}
            name='password'
            type={this.state.showPassword ? 'text' : 'password'}
            label={t('passwordInput:password')}
            error={error}
            className={className}
            noValidate
            onFocus={this.onFocus}
            onBlur={this.onBlur}
          />
          <PasswordToggle checked={this.state.showPassword} onChange={this.togglePassword} />
        </div>
        {(this.props.password.length > 3 && this.state.suggestions.length > 0) &&
          <div className={`auth-form__password-suggest ${this.state.warning ? 'is-snug' : ''}`}>
            <p className='auth-form__password-suggest__try'>{t('passwordInput:try')}</p>
            <div>
              {this.state.suggestions.map((suggestion) => (
                <p>{t(`${suggestion}`)}</p>
              ))}
            </div>
          </div>
        }
      </div>
    );
  }
}

export default withTranslation(['passwordInput', 'passwordFeedback'])(
  scriptLoader(`${process.env.PUBLIC_URL || ''}/zxcvbn.js`)(PasswordInput)
);



// WEBPACK FOOTER //
// ./src/components/shared/PasswordInput.js